var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c("h2", { staticClass: "px-3 pt-3" }, [
          _vm._v(_vm._s(_vm.$t("newTrip.selfOrOtherUser")))
        ]),
        _c(
          "v-row",
          { staticClass: "text-center" },
          [
            _c("v-spacer"),
            _c(
              "v-col",
              {
                staticClass: "choose-box elevation-5",
                attrs: { cols: "12", md: "4" }
              },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("newTrip.forSelf")))]),
                _c("v-icon", { attrs: { size: "150px" } }, [
                  _vm._v("perm_identity")
                ]),
                _c("br"),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function($event) {
                        return _vm.tripSelf()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.choose")))]
                )
              ],
              1
            ),
            _c("v-spacer"),
            _c(
              "v-col",
              {
                staticClass: "choose-box elevation-5",
                attrs: { cols: "12", md: "4" }
              },
              [
                _c("h3", [_vm._v(_vm._s(_vm.$t("newTrip.forOther")))]),
                _c("v-icon", { attrs: { size: "150px" } }, [
                  _vm._v("supervisor_account")
                ]),
                _c("br"),
                _c(
                  "v-select",
                  {
                    attrs: {
                      items: _vm.users,
                      label: _vm.$t("global.worker"),
                      "error-messages": _vm.errorMessages
                    },
                    model: {
                      value: _vm.selectedUser,
                      callback: function($$v) {
                        _vm.selectedUser = $$v
                      },
                      expression: "selectedUser"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("newTrip.chooseWorker")) + " ")]
                ),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function($event) {
                        return _vm.tripOther()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.choose")))]
                )
              ],
              1
            ),
            _c("v-spacer")
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }